/** @jsx jsx */
import { Box, Container, Grid, jsx } from 'theme-ui'
import RichTextRenderer from '~/components/Content/RichText'

const BodyCopySection = ({ body }) => {
  return (
    <Box pt={[7, null, 9]} pb={[8, null, 10]}>
      <Container>
        <Grid columns={[1, 12]} sx={{ rowGap: '0' }}>
          <Box
            sx={{
              gridColumn: [null, '2 / 12', null, '3 / 11'],
              'p:first-of-type': { mt: 0 },
              'p:last-of-type': { mb: 0 },
            }}
          >
            <RichTextRenderer richText={body} optionSet="body" />
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default BodyCopySection
